import React from 'react';

const StaticMap = (props) => {
    const { mapSource, mapUrl } = props;

    const handleClick = () => {
        window.open(mapUrl, '_blank', 'noopener,noreferrer');
    }

    return (
        mapSource ?
            <div role="button" className="container d-flex justify-content-center elements-spacing">
                <img src={mapSource} alt="clinicAddress" height={400} width={'100%'} onClick={handleClick} />
            </div> : null
    )
}

export default StaticMap;